import React, { useState } from 'react';
import { LogOut, User, ChevronDown } from 'lucide-react';
import { useAuth } from '../App';
import { Button } from './ui/button';

const MobileHeader = ({ title }) => {
  const { user, logout } = useAuth();
  const [showMenu, setShowMenu] = useState(false);

  const handleLogout = () => {
    logout();
    setShowMenu(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-gradient-to-r from-blue-900 to-blue-800 text-white z-40 safe-area-top shadow-md-2">
      <div className="flex items-center justify-between h-14 px-4">
        {/* Left: Logo and Title */}
        <div className="flex items-center gap-2">
          <img 
            src="/contribo-logo.png" 
            alt="Contribo" 
            className="h-8 w-8"
          />
          <h1 className="text-base font-bold">{title || 'Contribo'}</h1>
        </div>

        {/* Right: User Menu */}
        {user && (
          <div className="relative">
            <button
              onClick={() => setShowMenu(!showMenu)}
              className="flex items-center gap-2 p-2 rounded-lg active:bg-white active:bg-opacity-20 transition-colors"
              aria-label="User menu"
            >
              <div className="flex items-center gap-2">
                <User className="h-5 w-5" />
                <span className="text-sm max-w-24 truncate">{user.name?.split(' ')[0]}</span>
                <ChevronDown className={`h-4 w-4 transition-transform ${showMenu ? 'rotate-180' : ''}`} />
              </div>
            </button>

            {/* Dropdown Menu */}
            {showMenu && (
              <>
                <div 
                  className="fixed inset-0 z-40" 
                  onClick={() => setShowMenu(false)}
                />
                <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-md-3 overflow-hidden z-50">
                  <div className="p-3 bg-gray-50 border-b">
                    <p className="text-sm font-semibold text-gray-900 truncate">{user.name}</p>
                    <p className="text-xs text-gray-600 truncate">{user.email}</p>
                  </div>
                  <div className="py-1">
                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center gap-3 px-4 py-3 text-sm text-red-600 hover:bg-red-50 active:bg-red-100 transition-colors"
                    >
                      <LogOut className="h-4 w-4" />
                      Logout
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default MobileHeader;
